import { render, staticRenderFns } from "./RadioView.vue?vue&type=template&id=3a38ad6b&scoped=true"
import script from "./RadioView.vue?vue&type=script&lang=js"
export * from "./RadioView.vue?vue&type=script&lang=js"
import style0 from "./RadioView.vue?vue&type=style&index=0&id=3a38ad6b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a38ad6b",
  null
  
)

export default component.exports